module.exports = __webpack_public_path__ + "static/media/ic_cidadao.8ff3ddd5.svg";